module.exports = __webpack_public_path__ + "static/media/add-people-success-individual.357b29ac.png";